export default {
  issues: {
    subtasks: {
      hint: 'Subtasks: {done} of {total} done',
    },
    types: {
      ISSUE_TYPE_EPIC: 'Epic',
      ISSUE_TYPE_STORY: 'Story',
      ISSUE_TYPE_TASK: 'Task',
      ISSUE_TYPE_BUG: 'Bug',
      ISSUE_TYPE_SUBTASK: 'Subtask',
    },
    priorities: {
      PRIORITY_HIGHEST: 'Highest',
      PRIORITY_HIGH: 'High',
      PRIORITY_MEDIUM: 'Medium',
      PRIORITY_LOW: 'Low',
      PRIORITY_LOWEST: 'Lowest',
    },
    create: {
      action: 'Create task',
      inColumn: 'Task',
      title: 'New task',
      type: 'Type',
      name: 'Title',
      namePlaceholder: 'What needs to be done',
      description: 'Description',
      descriptionPlaceholder: 'Details, links, definition of done',
      priority: 'Priority',
      assignee: 'Assignee',
      assigneePlaceholder: 'Unassigned',
      noMembers: 'No members in the project yet',
      parent: 'Parent',
      parentPlaceholder: 'No parent',
      noParents: 'No suitable tasks',
      dueDate: 'Due date',
      submit: 'Create',
      created: 'Task {key} created',
      errors: {
        title: 'The title must be at most {limit} characters',
        failed: 'Could not create the task',
      },
    },
    list: {
      columns: {
        type: 'Type',
        key: 'Key',
        title: 'Title',
        status: 'Status',
        priority: 'Pri.',
        assignee: 'Assignee',
        due: 'Due',
      },
      groupBy: {
        label: 'Group by',
        status: 'status',
        assignee: 'assignee',
        priority: 'priority',
        type: 'type',
        none: 'no groups',
      },
      select: 'Select {key}',
      selectAll: 'Select all on this page',
      selected: '{count} task selected | {count} tasks selected',
      clearSelection: 'Clear selection',
      bulk: {
        label: 'Actions on the selected',
        status: 'Status',
        assignee: 'Assignee',
      },
      shown: 'Showing {shown} of {total}',
      pages: 'List pages',
      prev: 'Previous page',
      next: 'Next page',
      openIssue: 'Open issue {key}',
      changeStatus: 'Change status',
      changeAssignee: 'Change assignee',
      assignFailed: 'Could not change the assignee',
      noAssignee: 'Unassigned',
      noStatus: 'No status',
      noPriority: 'No priority',
      noType: 'No type',
      empty: {
        title: 'No tasks yet',
        description: 'Create the first one — it will show up both here and on the board.',
      },
      error: {
        title: 'Could not load the list',
        description: 'The service did not respond. Check your connection and try again.',
      },
    },
  },
  issue: {
    back: 'Back',
    titleLabel: 'Task title',
    saveFailed: 'Could not save the change',
    today: 'today',
    yesterday: 'yesterday',
    watch: 'Watch',
    unwatch: 'Unwatch',
    description: {
      empty: 'Add a description: terms, links, definition of done',
      edit: 'Click to edit',
    },
    history: {
      none: 'No changes yet',
      more: 'Show more',
      system: 'System',
      created: ' created the task',
      changed: ' changed the {field}:',
      empty: '—',
      fields: {
        title: 'title',
        description: 'description',
        type: 'type',
        priority: 'priority',
        assignee: 'assignee',
        parent: 'parent',
        due_date: 'due date',
        column: 'status',
        labels: 'labels',
        attributes: 'attributes',
        deleted: 'deletion',
      },
    },
    subtasks: {
      title: 'Subtasks',
      add: 'Add a subtask',
      placeholder: 'What needs doing',
      failed: 'Could not create the subtask',
    },
    links: {
      empty: 'No links yet',
      search: 'Key or task title',
      remove: 'Remove the link to {key}',
      types: {
        LINK_TYPE_BLOCKS: 'Blocks',
        LINK_TYPE_RELATES: 'Relates to',
        LINK_TYPE_DUPLICATES: 'Duplicates',
        LINK_TYPE_CAUSES: 'Causes',
      },
      outbound: {
        LINK_TYPE_BLOCKS: 'blocks',
        LINK_TYPE_RELATES: 'relates to',
        LINK_TYPE_DUPLICATES: 'duplicates',
        LINK_TYPE_CAUSES: 'causes',
      },
      inbound: {
        LINK_TYPE_BLOCKS: 'is blocked by',
        LINK_TYPE_RELATES: 'relates to',
        LINK_TYPE_DUPLICATES: 'is duplicated by',
        LINK_TYPE_CAUSES: 'is caused by',
      },
    },
    comments: {
      placeholder: "Comment… ({'@'} to mention, DEV-NNN links a task)",
      send: 'Send',
      empty: 'No comments yet',
      more: 'Show earlier',
      edit: 'Edit',
      remove: 'Delete',
    },
    peek: {
      open: 'Open page',
      activity: 'Activity',
    },
    dev: {
      title: 'GitLab',
      mr: {
        opened: 'In review',
        merged: 'Merged',
        closed: 'Closed',
        draft: 'Draft',
      },
      stand: {
        live: 'Environment up',
        removed: 'Environment removed',
      },
      pipeline: {
        success: 'Pipeline passed',
        failed: 'Pipeline failed',
        running: 'Pipeline running',
        pending: 'Pipeline queued',
        created: 'Pipeline created',
        canceled: 'Pipeline canceled',
        skipped: 'Pipeline skipped',
        manual: 'Pipeline awaits a run',
      },
    },
    pages: {
      title: 'Knowledge base',
      add: 'Link a page',
      search: 'Page title or text',
      nothing: 'Nothing found',
      remove: 'Unlink the page “{title}”',
    },
    attachments: {
      title: 'Attachments',
      add: 'Attach file',
      sending: 'Uploading…',
      remove: 'Delete file {name}',
      count: '{count} file | {count} files',
      kb: 'KB',
      mb: 'MB',
    },
    labels: {
      add: 'Add a label',
      remove: 'Remove label {name}',
      search: 'Label or a new name',
      create: 'Create “{name}”',
      none: 'No labels in this project yet',
    },
    activity: {
      label: 'Task activity',
      comments: 'Comments',
      history: 'History',
      links: 'Links',
    },
    meta: {
      fold: 'Details · assignee, due date, labels',
      status: 'Status',
      assignee: 'Assignee',
      priority: 'Priority',
      due: 'Due',
      noDue: 'No due date',
      labels: 'Labels',
      watchers: 'Watchers',
      epic: 'Epic',
      project: 'Project',
      crm: 'CRM link',
      crmKinds: {
        deal: 'Deal',
        client: 'Client',
        agent: 'Agent',
      },
      created: 'Created {date}',
      createdBy: 'Created {date}, {name}',
      updated: 'Updated {date}',
    },
    error: {
      title: 'Could not load the task',
      description: 'The service did not answer. Check the connection and try again.',
    },
  },
  board: {
    dropHere: 'Drop to move here',
    moveFailed: 'Could not move the task',
    scrollToEnd: 'To the last column',
    scrollToStart: 'To the first column',
    nothingFound: {
      title: 'Nothing found',
      description: 'There are tasks, but none match the filter. Clear it or change the query.',
    },
    empty: {
      title: 'The board is empty',
      description: 'Create the first task — or drag a card here from another column.',
    },
    error: {
      title: 'Could not load the board',
      description: 'The service did not answer. Check the connection and try again.',
      retry: 'Retry',
    },
  },
  projects: {
    summary: {
      projects: '{count} project | {count} projects',
      issues: '{count} open issue | {count} open issues',
      mine: 'you are on {count}',
    },
    searchPlaceholder: 'Search projects…',
    filters: {
      label: 'Which projects to show',
      all: 'All',
      mine: 'Mine',
      archived: 'Archived',
    },
    card: {
      inProgress: '{count} in progress',
      open: '{count} open',
      private: 'Private project',
    },
    empty: {
      title: 'No projects yet',
      description: 'Create the first one — a key, a name and an issue type profile.',
    },
    nothingFound: {
      title: 'Nothing found',
      description: 'Try another query or drop the filter.',
    },
    error: {
      title: 'Could not load projects',
      description: 'The service did not answer. Check the connection and try again.',
      retry: 'Retry',
    },
    create: {
      action: 'New project',
      title: 'New project',
      key: 'Key',
      keyPlaceholder: 'DEV',
      name: 'Name',
      namePlaceholder: 'Development',
      description: 'Description',
      descriptionPlaceholder: 'What the project is about and who works on it',
      profile: 'Project profile',
      profiles: {
        development: 'Development',
        simple: 'Simple',
      },
      profileHint: {
        development:
          'Epic, story, task, bug, subtask. Board: backlog, to do, in progress, review, testing, done.',
        simple: 'Tasks and subtasks only. Board: to do, in progress, done.',
      },
      private: 'Private project',
      privateHint: 'A private project is visible to its members only.',
      submit: 'Create',
      errors: {
        key: 'Uppercase Latin letters, two to ten',
        failed: 'Could not create the project',
      },
    },
  },
  settings: {
    personal: {
      title: 'Settings',
    },
    integrations: {
      title: 'Integrations',
      connect: {
        title: 'Connect an agent',
        step1: 'Issue an access key',
        step2: 'Run the command in your terminal',
        step2Hint: 'Substitute the issued key for the ellipsis: the tracker does not store it and cannot show it a second time.',
        copy: 'Copy',
        copied: 'Copied',
        repo: '— MCP server sources and the full list of tools',
      },
      keys: {
        title: 'Access keys',
        hint: 'A key acts on your behalf and can do no more than you can. Up to {limit} active.',
        hintNoLimit: 'A key acts on your behalf and can do no more than you can.',
        issue: 'Issue a key',
        revoke: 'Revoke',
        revoked: 'Key "{name}" revoked',
        empty: 'No keys yet',
        emptyHint: 'Issue the first one with the button above — it will show up in this list.',
        until: 'until {date}',
        revokedAt: 'revoked {date}',
        expired: 'expired',
        neverUsed: 'never used',
        today: 'today, {time}',
        yesterday: 'yesterday',
        daysAgo: '{n} day ago | {n} days ago',
        columns: {
          name: 'Name',
          access: 'Access',
          lastUsed: 'Last used',
          expiry: 'Expires',
        },
        scopes: {
          all: 'all your rights',
          tasks: 'tasks',
          tasksRead: 'tasks — read only',
          knowledge: 'knowledge base',
        },
      },
      capabilities: {
        title: 'What an agent does with your key',
        reads: {
          title: 'Reads',
          items: [
            'Projects, boards, columns and labels',
            'Tasks, comments, history and links',
            'Branches, MRs and pipelines of a task',
            'Knowledge base pages',
          ],
        },
        writes: {
          title: 'Changes',
          items: [
            'Creates tasks one by one and in batches',
            'Edits fields and descriptions',
            'Moves across columns, sets labels',
            'Writes comments and links tasks',
          ],
        },
        cannot: {
          title: 'Cannot',
          items: [
            'Start releases or flip flags',
            'Bring feature environments up or down',
            'Delete tasks, projects or pages',
            'Issue new keys',
          ],
        },
      },
      dialog: {
        title: 'Issue an access key',
        doneTitle: 'Key issued',
        name: 'Name',
        namePlaceholder: 'Claude Code · laptop',
        access: 'Access',
        scopeHint: 'A key can do no more than you can: its rights are intersected with yours. Releases, flags and environments are never included.',
        scopes: {
          'tracker:read': 'Tasks — read',
          'tracker:write': 'Tasks — write',
          'knowledge:read': 'Knowledge base — read',
          'knowledge:write': 'Knowledge base — write',
        },
        lifetime: 'Lifetime',
        ttl: {
          API_KEY_TTL_30_DAYS: '30 days',
          API_KEY_TTL_90_DAYS: '90 days',
          API_KEY_TTL_180_DAYS: '180 days',
          API_KEY_TTL_365_DAYS: 'A year',
        },
        submit: 'Issue',
        done: 'Done',
        secretHint: 'Copy the key now: it is shown once and will not appear anywhere again.',
        secretWarning: 'The key acts on your behalf. Do not commit it to a repository and do not send it over chat.',
        errors: {
          create: 'Could not issue the key',
        },
      },
      errors: {
        load: 'Could not load the keys',
        revoke: 'Could not revoke the key',
        copy: 'Clipboard is unavailable',
      },
    },
    cancel: 'Discard',
    save: 'Save',
    saved: 'Settings saved',
    saveFailed: 'Could not save the settings',
    error: {
      title: 'Could not load the settings',
      description: 'The service did not respond. Check the connection and try again.',
    },
    tabs: {
      columns: 'Columns',
      members: 'Members',
      types: 'Issue types',
      general: 'General',
    },
    columns: {
      preset: 'Preset:',
      presets: {
        COLUMN_PRESET_DEVELOPMENT: 'Development · 6 columns with WIP',
        COLUMN_PRESET_SIMPLE: 'Simple · 3 columns, no limits',
      },
      presetLocked:
        'A preset replaces the whole board, so it only applies to an empty project — this one already has issues.',
      hint: 'A preset sets the starting columns. You can edit them afterwards: name, colour, status category and WIP limit.',
      categories: {
        STATUS_CATEGORY_OPEN: 'Open',
        STATUS_CATEGORY_IN_PROGRESS: 'In progress',
        STATUS_CATEGORY_DONE: 'Done',
      },
      name: 'Column name',
      color: 'Column colour',
      wip: 'WIP:',
      wipLabel: 'WIP limit of the {name} column',
      remove: 'Remove the {name} column',
      add: 'Add a column',
      newName: 'New column',
      moveTitle: 'Where to move the issues',
      moveText:
        'The column holds {count} issue — pick where to move it. | The column holds {count} issues — pick where to move them.',
      moveTarget: 'Target column',
      moveSubmit: 'Remove the column',
    },
    members: {
      remove: 'Remove {name} from the project',
      title: 'Members',
      searchPlaceholder: 'Name or email of a VINPROP employee',
      role: 'Role',
      add: 'Add',
      nobody: 'Nobody found',
      noDirectory: 'The employee directory is unavailable: the users:read permission is required',
      directoryRoles: {
        ADMIN: 'Administrator',
        ADMIN_USER: 'Administrator',
        CEO: 'Executive',
        HOS: 'Head of sales',
        PROJECT_MANAGER: 'Project manager',
        MANAGER: 'Manager',
        MARKETER: 'Marketing',
        SUPPORT_MANAGER: 'Support',
        CONTENT_AUTHOR: 'Content',
      },
      roles: {
        MEMBER_ROLE_ADMIN: 'Admin',
        MEMBER_ROLE_MEMBER: 'Member',
        MEMBER_ROLE_VIEWER: 'Viewer',
      },
      hint: 'Admin — settings, members and issue deletion. Member — work with issues and the board. Viewer — read only. Access to the tracker itself is granted in auth.',
    },
    types: {
      profiles: {
        TYPE_PROFILE_DEVELOPMENT: 'Profile: development',
        TYPE_PROFILE_SIMPLE: 'Profile: simple',
      },
      hint: 'The set of types is fixed: Epic → Story → Task and Bug → Subtask. The profile turns types on and off; custom types do not exist.',
      notes: {
        ISSUE_TYPE_EPIC: 'Top level: a goal spanning weeks, collects stories and tasks',
        ISSUE_TYPE_STORY: 'User value, splits into tasks',
        ISSUE_TYPE_TASK: 'A unit of work for one assignee',
        ISSUE_TYPE_BUG: 'A defect: its own colour and high priority by default',
        ISSUE_TYPE_SUBTASK: 'A checklist inside an issue, never shown on the board',
      },
      count: '{count} issue | {count} issues',
    },
    general: {
      archive: 'Archive',
      archiveTitle: 'Archive the project',
      restoreTitle: 'Bring the project back',
      archiveNote:
        'An archived project leaves the hub and the sidebar. Its tasks stay reachable by link.',
      archiveAction: 'Archive',
      restoreAction: 'Bring back',
      archiveAsk:
        'The project disappears from the hub and the navigation. You can bring it back on this screen.',
      restoreAsk: 'The project shows up in the hub and the sidebar again.',
      archived: 'The project is archived',
      restored: 'The project is back',
      name: 'Project name',
      key: 'Key',
      keyNote: 'The key cannot be changed: issue numbers and GitLab branch matching depend on it.',
      description: 'Description',
      access: 'Access and rules',
      private: 'Private project',
      privateNote: 'Visible to project members and administrators only',
    },
  },
  editor: {
    mention: {
      empty: 'Nobody found',
    },
  },
  app: {
    name: 'VP Tracker',
  },
  login: {
    title: 'Sign in',
    email: 'Email',
    emailPlaceholder: "mk{'@'}vinprop.vn",
    password: 'Password',
    passwordPlaceholder: '••••••••••',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    submit: 'Sign in',
    or: 'or',
    google: 'Sign in with Google Workspace',
    footer: "Access is granted by the VINPROP administrator · vp-adm{'@'}vinprop.vn",
    errors: {
      invalid: 'Wrong email or password',
      unavailable: 'Sign-in service is unavailable. Try again in a minute',
    },
  },
  nav: {
    knowledgeShort: 'KB',
    myTasksShort: 'Mine',
    mobile: 'Navigation',
    myTasks: 'My tasks',
    projects: 'Projects',
    calendar: 'Calendar',
    devops: 'DevOps',
    knowledge: 'Knowledge base',
    projectsOverline: 'Projects',
    addProject: 'Add project',
    board: 'Board',
    issues: 'Issues',
    epics: 'Epics',
    projectSettings: 'Project settings',
    settings: 'Settings',
    userMenu: 'User menu',
    collapse: 'Collapse menu',
    expand: 'Expand menu',
    logout: 'Sign out',
  },
  toolbar: {
    search: 'Search…',
    create: 'Create',
    view: {
      label: 'Project view',
      board: 'Board',
      list: 'List',
    },
    filters: {
      assignee: 'Assignee',
      type: 'Type',
      priority: 'Priority',
      reset: 'Clear',
      empty: 'Nothing to pick from',
    },
  },
  views: {
    board: 'Board',
    issues: 'Issues',
    epics: 'Epics',
    calendar: 'Calendar',
    devops: 'DevOps',
    knowledge: 'Knowledge base',
    myTasks: 'My tasks',
    settings: 'Project settings',
  },
  errors: {
    forbidden: {
      ask: 'Request access',
      asked: 'The request is sent. The project admins will see it in their notifications.',
      askFailed: 'Could not send the request',
      title: 'No access to the project',
      description: 'The project is private. Ask a project admin for access.',
    },
    notFound: {
      title: 'Page not found',
      description: 'Check the address: the section could be renamed, the issue moved or deleted.',
    },
    back: 'To my tasks',
  },
  assistant: {
    title: 'Assistant',
    you: 'You',
    close: 'Close panel',
    history: 'Past conversations',
    newThread: 'New conversation',
    noThreads: 'No conversations about this page yet',
    untitled: 'Untitled',
    resize: 'Panel width',
    placeholder: 'Ask or give a command…',
    stop: 'Stop',
    waiting: 'Writing an answer…',
    quota: '{remaining} of {limit} requests left today',
    disclaimer:
      'The assistant sees the open page and works with issues on your behalf. Your question and the issues it reads go to Google Gemini — do not paste personal data of clients.',
    suggestions: {
      board: 'Summarise what is happening on the board',
      overdue: 'What is overdue in project DEV',
      compose: 'Turn my text into an issue',
    },
    context: {
      board: 'Board',
      issues: 'Issues',
      epics: 'Epics',
      'project-settings': 'Project settings',
      'knowledge-page': 'Knowledge base page',
      'knowledge-page-edit': 'Knowledge base page',
      'my-tasks': 'My tasks',
      projects: 'Projects',
      calendar: 'Calendar',
    },
    errors: {
      thread: 'Could not open the conversation',
      stream: 'The assistant is unavailable, try again',
    },
  },
  palette: {
    tab: 'Search',
    title: 'Quick jump',
    placeholder: 'A knowledge base page or an issue key…',
    hint: 'Type two characters to find a page. A key like DEV-1421 opens the issue.',
    nothing: 'Nothing found',
    openIssue: 'Open issue {key}',
  },
  onboarding: {
    title: 'Getting started · {done} of {total}',
    steps: {
      project: 'Create a project',
      issue: 'Create the first task',
      columns: 'Set up the board columns',
      team: 'Invite the team',
    },
  },
  calendar: {
    scope: {
      label: 'Whose tasks',
      mine: 'Mine',
      watching: 'Watching',
    },
    today: 'Today',
    prev: 'Previous month',
    next: 'Next month',
    more: '{count} more',
    empty: 'Nothing is due this month.',
    withoutDue: 'No due date: {count}',
    error: {
      title: 'Could not open the calendar',
      description: 'The service did not answer. Check the connection and try again.',
    },
  },
  hub: {
    activity: {
      title: 'Recent activity',
      empty: 'Nothing has happened yet. New tasks, comments and deploys will show up here.',
      someone: 'Someone',
      today: 'Today',
      yesterday: 'Yesterday',
      more: 'Show more',
      loading: 'Loading…',
      verbs: {
        created: 'created a task',
        moved: 'moved',
        comment: 'commented',
        merged: 'merged',
        devops: 'deployed',
        other: 'changed',
      },
    },
  },
  kb: {
    space: 'Space',
    updated: 'updated {when}',
    version: 'version {version}',
    related: 'Related issues',
    error: {
      title: 'Could not open the knowledge base',
      description: 'The service did not answer. Check the connection and try again.',
    },
    empty: {
      title: 'The knowledge base is empty',
      description:
        'There are no spaces yet — create the first one and pages will show up in the sidebar.',
    },
    pick: {
      title: 'Pick a page',
      description: 'The space tree is in the sidebar on the left.',
    },
    newSpace: {
      title: 'New space',
      key: 'Key',
      keyInvalid: 'Uppercase latin letters and digits, from two to sixteen',
      name: 'Name',
      create: 'Create a space',
      failed: 'Could not create the space',
    },
    blank: {
      title: 'The knowledge base is empty',
      description: 'Write the first page — it will show up in the tree on the left.',
      create: 'Create a page',
    },
    edit: {
      action: 'Edit',
      cancel: 'Cancel',
      crumb: '{title} — editing',
      titleLabel: 'Page title',
      titlePlaceholder: 'Page title',
      bodyPlaceholder: "Page text. / for blocks, {'@'} to mention",
      savedAt: '✓ Draft saved at {time}',
      saveVersion: 'Save version',
      saveFailed: 'Could not save the page',
      versionSaved: 'Version saved',
      restored: 'Version v{number} restored',
      previewing: 'Viewing version v{number}',
      closePreview: 'Close preview',
      commentLabel: 'What changed',
      commentPlaceholder: 'Optional: one line for the history',
    },
    versions: {
      title: 'Versions',
      empty: 'No versions yet. “Save version” takes a snapshot of the page.',
      number: 'v{number}',
      current: 'current',
      open: 'Open',
      restore: 'Restore',
    },
    tree: {
      menu: 'Page actions',
      addChild: 'Add a child page',
      move: 'Move',
      delete: 'Delete',
      newPage: 'New page',
      newPageTitle: 'New page',
      newParent: 'Move to',
      root: 'To the space root',
      moveTitle: 'Move “{title}”',
      deleteTitle: 'Delete “{title}”?',
      deleteHint: 'The page cannot be brought back.',
      deleteWithChildren: 'Every nested page goes with it. They cannot be brought back.',
      createFailed: 'Could not create the page',
      moveFailed: 'Could not move the page',
      deleteFailed: 'Could not delete the page',
    },
  },
  my: {
    filters: {
      project: 'Project',
      statusLabel: 'Status',
      status: {
        STATUS_CATEGORY_OPEN: 'To do',
        STATUS_CATEGORY_IN_PROGRESS: 'In progress',
        STATUS_CATEGORY_DONE: 'Done',
      },
      dueLabel: 'Due',
      due: {
        today: 'Today',
        week: 'This week',
      },
    },
    sort: {
      label: 'Order',
      due_date: 'By due date',
      priority: 'By priority',
      updated_at: 'By update',
      key: 'By key',
    },
    chips: {
      assigned: 'Assigned to me',
      watching: 'Watching',
      overdue: 'Overdue',
    },
    due: {
      today: 'today',
      tomorrow: 'tomorrow',
    },
    error: 'Could not load the issues',
    errorHint: 'The service did not answer. Check the connection and try again.',
    empty: {
      assigned: {
        title: 'Nothing is assigned to you',
        description: 'Issues show up here once you are made the assignee.',
      },
      watching: {
        title: 'You are not watching anything',
        description: 'Use “Watch” on an issue — it will appear here.',
      },
      overdue: {
        title: 'Nothing is overdue',
        description: 'All due dates are still ahead.',
      },
    },
  },
  epic: {
    list: {
      search: 'Search epics…',
      create: 'New epic',
      due: 'due {date}',
      error: {
        title: 'Could not load epics',
        description: 'The service did not respond. Check the connection and try again.',
      },
      empty: {
        title: 'No epics in this project',
        description: 'An epic keeps a large chunk of work together: stories, tasks and bugs.',
      },
      nothingFound: {
        title: 'Nothing found',
        description: 'There are epics, but none match the query. Check the spelling.',
      },
    },
    summary: {
      total: '{count} issue | {count} issues',
      done: '{count} done',
      inProgress: '{count} in progress',
      open: '{count} open',
    },
    progressLabel: 'Epic readiness',
    empty: 'The epic has no issues yet',
    pipelines: 'Epic pipelines · by service',
    noPipelines: 'No runs for the epic issues yet',
    ops: 'Flags and stands',
    activityGap:
      'There is no epic activity feed: the tracker keeps the history of a single issue, a shared feed does not exist yet.',
  },
  devops: {
    stand: {
      raise: 'Raise a stand',
      drop: 'Tear the stand down',
      raiseTitle: 'Raise a feature stand',
      dropTitle: 'Tear the feature stand down',
      raiseHint:
        'The button runs the deploy-feature job of the chosen branch. The pool is limited to 8 environments.',
      dropHint: 'The button runs the stop-feature job and frees a slot in the pool.',
      nothing: 'The issue has no branches in GitLab — nothing to raise.',
    },
    pipelines: {
      title: 'Pipelines',
      project: 'Project',
      allProjects: 'All projects',
      unassigned: 'No task',
      status: 'Status',
      noProjects: 'Nothing to choose from',
      searchPlaceholder: 'Search…',
      groupBy: 'Group the runs',
      byEpic: 'By epic',
      byService: 'By service',
      window: 'Window',
      windowDays: '{days} d',
      open: 'Open in GitLab',
      error: 'Could not load the runs',
      errorHint: 'The pipeline summary is unavailable. Try again.',
      kpi: {
        success: 'Passed · 24 h',
        successHint: 'of {total}',
        failed: 'Failed',
        running: 'Running now',
        duration: 'Average duration',
        delta: '{delta} s vs yesterday',
      },
      empty: {
        title: 'No runs yet',
        description:
          'The tracker learns about runs from GitLab webhooks: they show up after the first push to an issue branch.',
      },
    },
    envs: {
      title: 'Feature environments',
      searchPlaceholder: 'Search…',
      refresh: 'Refresh',
      retry: 'Try again',
      error: 'Could not load the environments',
      errorHint: 'The operations log is unavailable. Try again.',
      actionError: 'The action failed — check the branch pipeline in GitLab.',
      noIssue: 'no issue',
      note: 'The button runs the existing CI jobs: deploy-feature to raise and stop-feature to tear down. The tracker creates no pipeline of its own, it plays a job of the branch.',
      columns: {
        stand: 'Service',
        issue: 'Issue',
        branch: 'Branch',
        actor: 'By',
        uptime: 'Uptime',
        actions: 'Actions',
      },
      state: {
        active: 'running',
        building: 'building',
        idle: 'idle',
        buildingUptime: 'starting',
      },
      uptime: {
        days: 'd',
        hours: 'h',
        minutes: 'min',
      },
      metrics: {
        active: 'Running stands',
        activeHint: 'up right now',
        building: 'Starting',
        idle: 'Idle for over {days} days',
        idleHint: 'candidates to tear down',
      },
      filters: {
        project: 'Service',
        state: 'Status',
        noProjects: 'Nothing to choose from',
      },
      actions: {
        open: 'Open the pipeline',
        redeploy: 'Rebuild',
        drop: 'Tear down',
      },
      empty: {
        title: 'No stands are running',
        description: 'Raise one from an issue card or with the button in the toolbar.',
      },
      raise: {
        title: 'Raise a feature stand',
        hint: 'The button runs the deploy-feature job of the branch. The issue comes from the branch name — by convention it starts with the issue key.',
        service: 'Repository',
        branch: 'Branch',
        issue: 'Issue',
        unknownIssue: 'No issue with this key',
        servicePlaceholder: 'Pick a repository',
        branchPlaceholder: 'Pick a branch',
        defaultBranch: 'default branch',
        noRepositories: 'No connected repositories',
        noBranches: 'No branches found',
        pickRepository: 'Pick a repository first',
      },
    },
    flags: {
      loading: 'Loading…',
      button: 'Flags',
      title: 'Feature flags',
      note: 'A flag is switched by a commit to features/dev.json or features/prod.json in the infrastructure repository. Git stays the source of truth, the tracker shows the state and the history.',
      new: 'New flag',
      newTitle: 'New flag',
      newHint:
        'A flag is created in both environments at once: on in the chosen one, off in the other. The infrastructure lint requires that.',
      keyInvalid: 'A key looks like dev-1476-devops-screens: with an issue number, lowercase',
      create: 'Create the flag',
      error: 'Could not load the flags',
      errorHint:
        'The flags file is unavailable: check whether the GitLab integration is configured.',
      toggleError: 'Could not switch the flag',
      recent: 'Recent switches',
      turnedOn: 'turned on for {environment}',
      turnedOff: 'turned off for {environment}',
      noIssue: 'no issue in the key',
      searchPlaceholder: 'Search…',
      columns: {
        flag: 'Flag',
        what: 'Issue',
        changed: 'Last change',
      },
      filters: {
        environment: 'Environment',
        empty: 'Nothing to choose from',
      },
      empty: {
        title: 'No flags yet',
        description:
          'Create the first one — it will appear in features/dev.json and features/prod.json.',
      },
    },
    repos: {
      title: 'Repositories',
      sync: 'Sync now',
      ago: '{time} ago',
      events: 'push · MR · pipelines',
      noEvents: 'never arrived',
      open: 'Open in GitLab',
      connect: 'Connect',
      recheck: 'Reconnect',
      disconnect: 'Disconnect',
      error: 'Could not load repositories',
      empty: 'No repositories',
      emptyHint: 'The reconciliation has not run yet, or the group is empty',
      syncDone: 'Checked {checked}, connected {connected}, failed {failed}',
      syncFailed: 'Reconciliation failed',
      connected: '{path} connected',
      connectFailed: 'Could not connect the repository',
      disconnected: '{path} disconnected',
      disconnectFailed: 'Could not disconnect the repository',
      note: 'Group webhooks are a paid GitLab feature, so the hook goes on every repository separately. The tracker reconciles the group on a schedule and delivers the hook where it is missing: a new repository connects itself.',
      filters: {
        state: 'State',
      },
      columns: {
        path: 'Repository',
        events: 'Events',
        lastEvent: 'Last event',
        actions: 'Actions',
      },
      state: {
        connected: 'connected',
        missing: 'no hook',
        failed: 'hook disabled',
        muted: 'disconnected',
      },
      metrics: {
        connected: 'Connected',
        connectedHint: 'of {total} repositories',
        missing: 'No hook',
        missingHint: 'no events arrive',
        failed: 'Failing',
        failedHint: 'GitLab rejected the hook',
        synced: 'Synced',
        syncedHint: 'last reconciliation',
      },
    },
    releases: {
      views: {
        label: 'History view',
        flat: 'Flat',
        grouped: 'By repository',
      },
      inRepository: '{n} release | {n} release | {n} releases',
      title: 'Releases',
      history: 'Release history',
      searchPlaceholder: 'Search…',
      error: 'Could not load the releases',
      errorHint: 'The operations log is unavailable. Try again.',
      tagged: 'tagged',
      failed: 'failed',
      open: 'Open in GitLab',
      note: 'The tag is created through the GitLab API. Deploying to prod stays a manual step of the pipeline.',
      filters: {
        service: 'Service',
        period: 'Period',
        days: 'Last {days} days',
        buildLabel: 'Build',
        build: {
          success: 'Passed',
          failed: 'Failed',
          running: 'Running',
          none: 'No build',
        },
        empty: 'Nothing to choose from',
      },
      order: {
        label: 'Order',
        newest: 'Newest first',
        oldest: 'Oldest first',
      },
      noBuild: 'no build',
      empty: {
        title: 'No releases yet',
        description:
          'No tags have been cut through the tracker. Tags made by hand are not in the log.',
      },
    },
    release: {
      button: 'Release',
      title: 'Cut a release',
      hint: 'The tag goes onto master. The service list is a hint, the repository can be typed by hand.',
      service: 'Service',
      tag: 'Version',
      tagInvalid: 'A version looks like v1.4.0',
      description: 'Description',
      create: 'Create the tag',
    },
  },
}
